import Vue from 'vue'
import Router from 'vue-router'
import routesAuthorized from '@/router/routes'
import Cookies from 'js-cookie'

function getRouteByViewName(view: string) {
  switch (view) {
    /* OUTRAS ROTAS */
    case 'home-transitoria':
      return '/home'
    case 'financeiro':
      return '/financeiro'
    case 'recebimento':
      return '/recebimento'
    case 'agendamento-medico':
      return '/agendamento-medico'
    case 'relatorio':
      return '/relatorio/fonte-pagadora'
    case 'producao':
      return '/producao'
    case 'calculadora':
      return '/calculadora'
    case 'dashboard':
      return '/dashboard'
    case 'backoffice-contratos':
      return '/backoffice/contratos'

    /* ROTAS DO BACKOFFICE */
    case 'backoffice-agendamento':
      return '/backoffice/agendamento'
    case 'backoffice-autorizacao':
      return '/backoffice/autorizacao'
    case 'backoffice-suprimentos':
      return '/backoffice/suprimentos'
    case 'backoffice-pre-anestesico':
      return '/backoffice/pre-anestesico'
    case 'backoffice-mapa-cirurgico':
      return '/backoffice/mapa-cirurgico'
    case 'backoffice-mapa-cirurgico-grade':
      return '/backoffice/mapa-cirurgico-grade'
    case 'backoffice-orcamento':
      return '/backoffice/orcamento'
    case 'backoffice-cadastro-medico':
      return '/backoffice/cadastro-medico'
    case 'backoffice-notificacoes':
      return '/backoffice/notificacoes'
    case 'backoffice-chat-agendamento':
      return '/backoffice/chat'
    case 'backoffice-chat-autorizacao':
      return '/backoffice/chat'
    case 'backoffice-chat':
      return '/backoffice/chat'
    case 'operadora-fidelizacao':
      return '/backoffice/fidelizacao'
    case 'backoffice-regulacao':
      return '/backoffice/regulacao'

    default:
      return '/'
  }
}

function route(path: string, view: string, name: string, meta: any) {
  const obj = {
    name: name || view,
    path,
    component: (resolve: any) => import(`@/views/${view}.vue`).then(resolve),
    meta,
  }

  return obj
}

function defaultRoute() {
  // @ts-ignore
  const stringUserData: any = localStorage.getItem(`oidc.user:${window.API_FINX_AUTH}:portal-client`)
  const userDefaultRoute: any = { }

  if (stringUserData) {
    const userData = JSON.parse(stringUserData)
    // Map page authorized to set the default user route
    if (userData && userData.profile && userData.profile.pageAuthorized && Array.isArray(userData.profile.pageAuthorized)) {
      userData.profile.pageAuthorized.forEach((c) => {
        const r = new RegExp('default').test(c)
        if (r) {
          const config: any = JSON.parse(c)
          userDefaultRoute.component = (resolve: any) => import(`@/views/${config.view}.vue`).then(resolve)
          // This is the best solution by Thomas. Please, don't try to improve it...
          userDefaultRoute.name = 'default'
          userDefaultRoute.view = config.view
          userDefaultRoute.path = '/'
          userDefaultRoute.redirect = getRouteByViewName(config.view)
          userDefaultRoute.meta = {
            keyAuthorized: config.keyAuthorized,
            showMenu: config.showMenu,
            isPublic: config.isPublic,
          }

          if (config.view.includes('backoffice')) userDefaultRoute.meta.area = config.view.substring('backoffice-'.length).toLowerCase()
        }
        return c
      })
    }
  }
  return userDefaultRoute
}

function selectRouters() {
  const r = routesAuthorized.map(path => route(path.path, path.view, path.name, path.meta))
  const dRoute = defaultRoute()
  if (dRoute.name || dRoute.view) {
    r.push(dRoute)
  }

  return r
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: selectRouters(),
  scrollBehavior(to, from, savedPosition) {
    // ts-ignore
    // this.$ga.page(to.name)

    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return { selector: to.hash }
    }

    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const env: any = window
  const allowedRoutes: string[] = [
    'inicio',
    'cadastroMedico',
    'assinatura',
    'BackofficeContratos',
    'BackofficeContratosDetails',
    'FinanceiroUploadNotaFiscal',
    'termos-de-uso',
    'politica-de-privacidade',
  ]

  const cookie = localStorage.getItem(`oidc.user:${env.API_FINX_AUTH}:portal-client`)

  const postLoginUrl = Cookies.get('postLoginUrl')
  if (cookie) {
    const portalClient = JSON.parse(cookie || '')
    // @ts-ignore
    if (to.meta.isAuthorized || (portalClient.profile.pageAuthorized && portalClient.profile.pageAuthorized.includes(to.meta.keyAuthorized))) {
      if (postLoginUrl) {
        Cookies.remove('postLoginUrl')
        window.location.href = `${window.location.origin}${postLoginUrl}`
      } else {
        next()
      }
    } else {
      next('/inicio')
    }
    // if (to.name === 'SolicitacaoCirurgia' && from.name === null) next({ name: 'SolicitacaoCirurgiaDetails', params: { ...to.params } })
    // @ts-ignore
  } else if (!allowedRoutes.includes(to.name)) {
    Cookies.set('postLoginUrl', to.fullPath)
    next('/inicio')
  } else {
    next()
  }
})

export default router
